const { adminCall } = require("./_utils");

module.exports = {
  create: data => adminCall("profile.create", data),
  modify: data => adminCall("profile.modify", data),
  remove: uid => adminCall("profile.remove", {uid})
}
